import { render } from "./TableViewPropsCmp.vue?vue&type=template&id=241b4cd9"
import script from "./TableViewPropsCmp.vue?vue&type=script&lang=js"
export * from "./TableViewPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__